import angular from "angular";

angular
    .module('app')
    .component('coursePriorityModal', {
        template: require('./course-priority-modal.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.title = null;
    $ctrl.course = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.priority = $ctrl.course.priority;
    };

    $ctrl.submit = function () {
        $http
            .post(`/admin/courses/${$ctrl.course.id}/update-priority`, {priority: $ctrl.priority})
            .then(
                function (response) {
                    Notifier.success('Приоритет обновлен', 2);
                    $ctrl.close({
                        $value: {priority: $ctrl.priority}
                    });
                },
                function () {
                    Notifier.error('Произошла ошибка', 2);
                }
            )
    }
}
